import "whatwg-fetch";
import Vue from "vue";
import App from "./App";
import router from "./router";
import { createProvider } from "./vue-apollo";
import VueLocalStorage from "vue-localstorage";
import store from "./components/private/store/store";
import gql from "graphql-tag";
import PortalVue from "portal-vue";
// import "element-ui/lib/theme-chalk/display.css";
import "./theme.scss";
import "./utils/polyfill";

Vue.config.productionTip = false;

import i18n from "./i18n";

// Storage
Vue.use(VueLocalStorage, {
	bind: true
});

Vue.use(PortalVue);

// Globals
window.globalErrors = [];
window.Vue = Vue;
window.gql = gql;

require("./lang");
require("./vendor");
require("./filters");
require("./directives");
require("./global-components");

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	store,
	components: { App },
	provide: createProvider().provide(),
	i18n,
	template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js